import React from 'react'
import { ACTIVITY_SECTIONS } from 'constants/enums'

export default function(activitySection) {
  if (activitySection === ACTIVITY_SECTIONS.skill.id) {
    return <i className='ico ico--skill' />
  } else if (activitySection === ACTIVITY_SECTIONS.service.id) {
    return <i className='ico ico--service' />
  } else if (activitySection === ACTIVITY_SECTIONS.physical_recreation.id) {
    return <i className='ico ico--physical_recreation' />
  } else if (activitySection === ACTIVITY_SECTIONS.adventurous_journey.id) {
    return <i className='ico ico--adventurous_journey' />
  } else if (activitySection === ACTIVITY_SECTIONS.residential_project.id) {
    return <i className='ico ico--residential_project' />
  }
  return <i />
}
